import { z } from 'zod';
import { isoDateString } from '../_shared/dates.js';
import { personName } from '../_shared/person-name.js';
/**
 * Dossier sans PNR : séjour réservé en direct chez le fournisseur (confirmation
 * Disneyland, Bedsonline…). Ce bloc tient lieu de l'extraction Affidium ; la référence
 * du fournisseur voyage, elle, dans `bookingReference`, comme un PNR.
 *
 * Départ et arrivée sont des codes IATA : IGA refuse un lieu de transport inconnu.
 */
export const bookingWithoutPnrSchema = z.object({
    arrivalLocation: z.string().length(3),
    departureDate: isoDateString(),
    departureLocation: z.string().length(3),
    /** Identité de base ; le reste (naissance, prix…) suit dans `passengers`, par `travellerId`. */
    passengers: z
        .array(z.object({
        firstName: personName(),
        lastName: personName(),
        travellerId: z.string().min(1),
    }))
        .min(1),
    returnDate: isoDateString(),
});
/**
 * L'extraction qu'Affidium aurait renvoyée pour ce séjour : sans vol, sans compagnie,
 * sans échéance compagnie. Partagée par le formulaire (qui l'affiche comme un PNR
 * récupéré) et le serveur (qui crée le dossier à partir d'elle).
 */
export function buildExtractionWithoutPnr(input) {
    return {
        booking: {
            accountCode: null,
            arrivalLocation: input.arrivalLocation,
            companyIataCode: null,
            currency: 'EUR',
            departureDate: input.departureDate,
            departureLocation: input.departureLocation,
            fareValidityDeadline: null,
            installmentPassengerCount: input.passengers.length,
            installmentRefundableFee: null,
            installmentXRoles: [],
            pnr: null,
            returnDate: input.returnDate,
            seatCodes: [],
            ticketingDeadline: null,
            totalPrice: 0,
        },
        customer: { email: null, firstName: '', lastName: '', phone: null },
        flightSegments: [],
        passengers: input.passengers.map((passenger) => ({
            firstName: passenger.firstName,
            lastName: passenger.lastName,
            birthDate: null,
            fidelityCardCompany: null,
            fidelityCardNumber: null,
            gender: null,
            identityDocumentExpiryDate: null,
            identityDocumentNumber: null,
            identityDocumentType: null,
            issuingCountry: null,
            ticketNumbers: [],
            xRef: passenger.travellerId,
        })),
    };
}
